import {
  ChipProps as MantineChipProps,
  Chip as MantineChip,
} from '@mantine/core';

export type ChipProps = MantineChipProps;

export const Chip = MantineChip;

Chip.displayName = 'Chip';
